<!-- 直播列表 -->
<template>
  <div class="v-wrap" v-loading="loadingPage">
    <template v-if="liveOptParty==2 || liveOptParty==0">
      <h1>{{$t('lives.option[2]')}}</h1>
      <div v-if="liveList.length > 0">
        <div class="v-more-live-box">
          <div class="v-live-wrap">
              <el-row :gutter="20" style="width: 100%">
                  <el-col :xs="24" :sm="8" v-for="item in liveList" :key="item.id">
                      <v-live-card  @callback="callback" :vData="item" class="v-live-card"> </v-live-card>
                  </el-col>
              </el-row>
          </div>
        </div>
        <div class="v-page-box">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="totalPage"
            :page-size="pageRows"
            :current-page="pageNum"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>
      <div v-else>
        <div class="noData">
          {{ $t('common.noData') }}
        </div>
      </div>
    </template>
    <template v-if="liveOptParty==1 || liveOptParty==0">
      <h1>{{$t('lives.option[1]')}}</h1>
      <div v-if="liveList1.length > 0">
        <div class="v-more-live-box" v-if="liveList1.length > 0">
          <div class="v-live-wrap">
                <el-row :gutter="20" style="width: 100%">
                    <el-col :xs="24" :sm="8" v-for="item in liveList1" :key="item.id">
                         <v-live-card @callback="callback" :vData="item" class="v-live-card"> </v-live-card>
                    </el-col>
                </el-row>
          </div>
        </div>
        <div class="v-page-box" v-if="liveList1.length > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="totalPage1"
            :page-size="pageRows"
            :current-page="pageNum1"
            @current-change="changePage1">
          </el-pagination>
        </div>
      </div>
      <div v-else>
        <div class="noData">
          {{ $t('common.noData') }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import vLiveCard from '@/components/live/vLiveCard'
import liveMixin from '@/mixins/live.js'
import {
    mapGetters
} from 'vuex'

export default {
  data() {
      return {
        loadingPage: false
      }
  },
  components: {
    vLiveCard
  },
  computed: {
    ...mapGetters(['subjectType']),
  },
  mixins: [liveMixin],
  created() {
    if(this.subjectType == 'ACTOR') {
      this.commitState({
          'key': 'liveOptParty',
          'val': 1
      })
    } else {
      this.commitState({
          'key': 'liveOptParty',
          'val': 0
      })
    }
    this.commitAndLoadData(1)
    this.commitAndLoadData(2)
  }
}
</script>
<style lang="stylus" scoped>
h1 {
    line-height: 48px;
}

.v-more-live-box{
    .v-live-wrap{
        width:100%;
        max-width:$container-width;
        margin:40px auto 24px;
        display:flex;
        justify-content:flex-start;
        flex-wrap:wrap;
        .v-live-card{
            margin: 0 20px 20px 0;
        }
    }
}
.v-page-box{
    padding:15px 0;
}
.v-no-data{
    min-height:80vh;
}
.noData{
    width 100%
    height 60px
    line-height 60px
    text-align: center;
    color $color-black-65
}
</style>
